<template>
  <div>
    <!-- Special route handling for Callback to ensure auth processing occurs -->
    <div v-if="$route.path === '/callback'">
       <router-view></router-view>
    </div>

    <!-- Landing Page for Unauthenticated Users -->
    <div v-else-if="!authenticated" class="landing-page d-flex align-items-center justify-content-center">
       <div class="text-center">
          <img src="@/assets/sj-logo.png" alt="SpotJockeys Logo" class="mb-2" style="max-height: 100px; width: auto;" />
          <h1 class="display-4 mb-4">Welcome to SpotJockeys</h1>
          <p class="lead mb-4">Please log in to access your dashboard.</p>
          <div class="card d-inline-block p-4 shadow" style="min-width: 320px;">
             <h4 class="mb-4 text-muted">Portal Access</h4>
             <button class="btn btn-info btn-lg btn-block btn-fill" @click.prevent="login">
                Login
             </button>
          </div>
       </div>
    </div>

    <!-- Main Dashboard for Authenticated Users -->
    <div v-else class="wrapper" :class="wrapperClasses">
      <!-- Sidebar -->
      <div class="sidebar" :data-color="sidebarColor" :data-image="sidebarImage" :class="{'d-none': !sidebarVisible && windowWidth >= 991, 'mobile-open': sidebarVisible && windowWidth < 991}">
      <div class="sidebar-wrapper">
        <div class="logo">
          <a href="#" class="simple-text">
            <img src="@/assets/sj-logo.png" alt="Logo" style="height: 40px; margin-right: 10px;" />
            SpotJockeys
          </a>
        </div>
        <ul class="nav">
          <li class="nav-item" :class="{ active: $route.path === '/' }">
            <router-link class="nav-link" to="/">
              <i class="nc-icon nc-chart-pie-35 fas fa-chart-pie"></i>
              <p>Dashboard</p>
            </router-link>
          </li>
          <!-- <li class="nav-item" :class="{ active: $route.path === '/about' }">
            <router-link class="nav-link" to="/about">
              <i class="nc-icon nc-circle-09 fas fa-user"></i>
              <p>User Profile</p>
            </router-link>
          </li> -->

           <!-- Sales Management Group -->
           <li class="nav-item">
             <a class="nav-link" v-b-toggle.collapse-sales>
               <i class="nc-icon nc-bank fas fa-university"></i>
               <p>Sales Mgmt <b-icon icon="chevron-down" class="float-right" style="font-size: 0.8rem; margin-top: 4px;"></b-icon></p>
             </a>
             <b-collapse id="collapse-sales" class="pl-3">
               <ul class="nav">
                 <li :class="{ active: $route.path === '/purchase-queue' }">
                    <router-link class="nav-link" to="/purchase-queue">
                      <p class="mini-text">PQ</p>
                      <p>Purchase Queue</p>
                    </router-link>
                 </li>
                 <li :class="{ active: $route.path === '/rescheduled-sales' }">
                    <router-link class="nav-link" to="/rescheduled-sales">
                      <p class="mini-text">RS</p>
                      <p>Rescheduled Event Sales</p>
                    </router-link>
                 </li>
               </ul>
             </b-collapse>
           </li>

           <!-- Listings Group -->
           <li class="nav-item">
             <a class="nav-link" v-b-toggle.collapse-listings>
               <i class="nc-icon nc-notes fas fa-list"></i>
               <p>Listings <b-icon icon="chevron-down" class="float-right" style="font-size: 0.8rem; margin-top: 4px;"></b-icon></p>
             </a>
             <b-collapse id="collapse-listings" class="pl-3">
               <ul class="nav">
                  <li :class="{ active: $route.path === '/listing' }">
                    <router-link class="nav-link" to="/listing">
                      <p class="mini-text">CL</p>
                      <p>Create Listing</p>
                    </router-link>
                 </li>
                 <li :class="{ active: $route.path === '/current-listings' }">
                    <router-link class="nav-link" to="/current-listings">
                      <p class="mini-text">AL</p>
                      <p>Active Listings</p>
                    </router-link>
                 </li>
                 <li :class="{ active: $route.path === '/parkwhiz' }">
                    <router-link class="nav-link" to="/parkwhiz">
                      <p class="mini-text">PW</p>
                      <p>ParkWhiz</p>
                    </router-link>
                 </li>
               </ul>
             </b-collapse>
           </li>

           <!-- Analytics Group -->
           <li class="nav-item">
             <a class="nav-link" v-b-toggle.collapse-analytics>
               <i class="nc-icon nc-chart-bar-32 fas fa-chart-bar"></i>
               <p>Analytics <b-icon icon="chevron-down" class="float-right" style="font-size: 0.8rem; margin-top: 4px;"></b-icon></p>
             </a>
             <b-collapse id="collapse-analytics" class="pl-3">
               <ul class="nav">
                 <li :class="{ active: $route.path === '/metrics' }">
                    <router-link class="nav-link" to="/metrics">
                      <p class="mini-text">VM</p>
                      <p>Venue Metrics</p>
                    </router-link>
                 </li>
               </ul>
             </b-collapse>
           </li>

           <!-- Configuration Group -->
          <li class="nav-item">
             <a class="nav-link" v-b-toggle.collapse-config>
               <i class="nc-icon nc-settings-gear-64 fas fa-cogs"></i>
               <p>Configuration <b-icon icon="chevron-down" class="float-right" style="font-size: 0.8rem; margin-top: 4px;"></b-icon></p>
             </a>
             <b-collapse id="collapse-config" class="pl-3">
               <ul class="nav">
                 <li :class="{ active: $route.path === '/venues' }">
                    <router-link class="nav-link" to="/venues">
                      <p class="mini-text">VM</p> 
                      <p>Venue Management</p>
                    </router-link>
                 </li>
                 <li :class="{ active: $route.path === '/lotmap' }">
                    <router-link class="nav-link" to="/lotmap">
                      <p class="mini-text">LM</p>
                      <p>Lot Mapping</p>
                    </router-link>
                 </li>
                  <li :class="{ active: $route.path === '/config' }">
                    <router-link class="nav-link" to="/config">
                      <p class="mini-text">P</p>
                      <p>Processing</p>
                    </router-link>
                 </li>
                 <li :class="{ active: $route.path === '/event-mapping' }">
                    <router-link class="nav-link" to="/event-mapping">
                      <p class="mini-text">EM</p>
                      <p>Event Mapping</p>
                    </router-link>
                 </li>
               </ul>
             </b-collapse>
          </li>

          <!-- <li class="nav-item active-pro">
            <router-link class="nav-link" to="/parkwhiz">
              <i class="nc-icon nc-alien-33 fas fa-rocket"></i>
              <p>ParkWhiz</p>
            </router-link>
          </li> -->
        </ul>
      </div>
    </div>

    <!-- Mobile Overlay -->
    <div v-if="isMobile && sidebarVisible" class="mobile-overlay" @click="toggleSidebar"></div>

    <div class="main-panel">
      <!-- Navbar -->
      <nav class="navbar navbar-expand-lg " color-on-scroll="500">
        <div class="container-fluid">
          <div class="d-flex align-items-center">
              <!-- Desktop Toggle Button -->
              <button v-if="!isMobile" class="btn btn-simple btn-icon mr-2" @click="toggleSidebar">
                 <i class="fas" :class="sidebarVisible ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
              </button>
              
              <!-- Mobile Hamburger Menu (Left) -->
              <div v-if="isMobile" style="margin-right: 1.5rem;">
                  <button class="navbar-toggler d-block border-0" type="button" @click.stop="toggleSidebar" style="position: relative; width: 30px; height: 30px;">
                    <span class="navbar-toggler-bar burger-lines"></span>
                    <span class="navbar-toggler-bar burger-lines"></span>
                    <span class="navbar-toggler-bar burger-lines"></span>
                  </button>
              </div>
              
              <a class="navbar-brand" href="#"> {{ $route.name || 'Dashboard' }} </a>
          </div>

          <div class="collapse navbar-collapse justify-content-end" :class="{show: showMobileMenu}">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item" v-if="!$auth.isAuthenticated()">
                <a class="nav-link" href="#" @click.prevent="$auth.login()">
                  <span class="no-icon">Login</span>
                </a>
              </li>
              
              <b-nav-item-dropdown right v-if="$auth.isAuthenticated()" no-caret class="user-dropdown">
                <!-- Trigger -->
                <template #button-content>
                    <div class="d-inline-flex align-items-center">
                        <span class="px-3 py-1 border rounded-pill bg-light text-secondary shadow-sm d-flex align-items-center" style="font-size: 0.85rem; min-width: 150px; justify-content: space-between;">
                            <span class="d-flex align-items-center">
                                <i class="fas fa-user-circle mr-2"></i>
                                <span class="text-truncate" style="max-width: 120px;">{{ userProfile ? (userProfile.nickname || userProfile.name) : 'User' }}</span>
                            </span>
                            <i class="fas fa-chevron-down small ml-2"></i>
                        </span>
                    </div>
                </template>
                
                <!-- Expanded Header -->
                <b-dropdown-header v-if="userProfile" class="pt-2 pb-2">
                    <div class="font-weight-bold text-dark" style="font-size: 1rem;">{{ userProfile.name || userProfile.nickname }}</div>
                    <div class="small text-muted text-truncate">{{ userProfile.email }}</div>
                </b-dropdown-header>
                
                <b-dropdown-divider></b-dropdown-divider>
                
                <!-- Theme Toggle -->
                <b-dropdown-item @click="toggleTheme" class="d-flex justify-content-between align-items-center" link-class="d-flex justify-content-between align-items-center w-100">
                    <span>Theme</span>
                    <i class="fas" :class="darkMode ? 'fa-sun text-warning' : 'fa-moon text-secondary'"></i>
                </b-dropdown-item>
                
                <b-dropdown-divider></b-dropdown-divider>
                
                <!-- Logout -->
                <b-dropdown-item @click="$auth.logout()">
                    <span class="text-danger">Log out</span>
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </ul>
          </div>
        </div>
      </nav>
      <!-- End Navbar -->
      <div class="content">
        <div class="container-fluid">
            <router-view></router-view>
        </div>
      </div>
      <footer class="footer">
        <div class="container-fluid">
          <nav>
            <ul class="footer-menu">
              <li>
                <a href="#">
                  Home
                </a>
              </li>
              <li>
                <a href="#">
                  Company
                </a>
              </li>
            </ul>
            <p class="copyright text-center">
              © {{ new Date().getFullYear() }} <a href="#">SpotJockeys</a>
            </p>
          </nav>
        </div>
      </footer>
    </div>

    <!-- Session Warning Modal -->
    <b-modal v-model="sessionWarningModal" title="Session Expiring" hide-footer centered no-close-on-backdrop no-close-on-esc header-bg-variant="warning" header-text-variant="white">
      <div class="text-center p-3">
        <i class="fas fa-clock fa-3x text-warning mb-3"></i>
        <h4 class="mb-3">Are you still there?</h4>
        <p>Your session will expire in less than 5 minutes.</p>
        <p>Would you like to continue your session?</p>
        <div class="mt-4">
          <b-button variant="secondary" class="mr-3" @click="logout">Logout</b-button>
          <b-button variant="primary" @click="refreshSession">Continue Session</b-button>
        </div>
      </div>
    </b-modal>

    <!-- Session Expired Modal -->
    <b-modal v-model="sessionExpiredModal" title="Session Expired" hide-footer centered no-close-on-backdrop no-close-on-esc header-bg-variant="danger" header-text-variant="white">
      <div class="text-center p-3">
        <i class="fas fa-lock fa-3x text-danger mb-3"></i>
        <h4 class="mb-3">Session Expired</h4>
        <p>Your session has expired due to inactivity.</p>
        <p>Please log in again to continue.</p>
        <div class="mt-4">
          <b-button variant="primary" block @click="login">Login Again</b-button>
        </div>
      </div>
    </b-modal>
  </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      sidebarColor: 'black', 
      sidebarImage: '', 
      showMobileMenu: false,
      sidebarVisible: true,
      windowWidth: window.innerWidth,
      authenticated: false,
      sessionWarningModal: false,
      sessionExpiredModal: false,
      sessionCheckInterval: null,
      darkMode: false,
      userProfile: null
    }
  },
  created() {
    this.isAuthenticated();
    if (this.authenticated) {
        this.fetchProfile();
    }

    this.$auth.on('authenticated', () => {
       this.isAuthenticated();
       this.fetchProfile();
       this.startSessionCheck();
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    
    // Set initial sidebar state for mobile
    if (this.windowWidth < 991) {
       this.sidebarVisible = false;
    }
  },
  mounted() {
    if (this.authenticated) {
      this.startSessionCheck();
    }
    // Check for saved theme
    if (localStorage.getItem('darkMode') === 'true') {
      this.darkMode = true;
      document.body.classList.add('dark-mode');
    }
  },
  beforeDestroy() {
    if (this.sessionCheckInterval) clearInterval(this.sessionCheckInterval);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    if (this.sessionCheckInterval) clearInterval(this.sessionCheckInterval);
  },
  methods: {
      login() {
        this.$auth.login();
      },
      fetchProfile() {
        if (this.authenticated) {
            this.$auth.getProfile((err, profile) => {
                if (!err) {
                    this.userProfile = profile;
                }
            });
        }
      },
      isAuthenticated() {
        this.authenticated = this.$auth.isAuthenticated();
      },
      handleResize() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 991) {
           // On mobile init, hide sidebar if it wasn't explicitly interacted with? 
           // Or just leave it controlle by user. 
           // Usually we want it hidden by default on mobile.
           // But if we resize from desktop to mobile, it should probably hide.
           // For simplicity, let's strictly control layout via CSS + a state class.
        }
      },
      toggleSidebar() {
        this.sidebarVisible = !this.sidebarVisible;
        if (this.windowWidth < 991) {
           this.showMobileMenu = !this.showMobileMenu;
        }
      },
      startSessionCheck() {
          if (this.sessionCheckInterval) clearInterval(this.sessionCheckInterval);
          // Check every minute
          this.sessionCheckInterval = setInterval(() => {
              this.checkSessionStatus();
          }, 60000); 
          // Also check immediately
          this.checkSessionStatus();
      },
      checkSessionStatus() {
          if (!this.authenticated) return;
          
          const expiresAt = this.$auth.getExpiresAt();
          if (!expiresAt) return;
          
          const now = new Date().getTime();
          const timeLeft = expiresAt - now;
          
          if (timeLeft <= 0) {
              this.sessionWarningModal = false;
              this.sessionExpiredModal = true;
          } else if (timeLeft < 300000) { // Less than 5 minutes (300000 ms)
              // Only show if not already showing expired
              if (!this.sessionExpiredModal && !this.sessionWarningModal) {
                  this.sessionWarningModal = true;
              }
          }
      },
      refreshSession() {
          this.$auth.renewSession()
              .then(() => {
                  this.sessionWarningModal = false;
                  this.$bvToast.toast('Session extended successfully', {
                      title: 'Session',
                      variant: 'success',
                      solid: true,
                      autoHideDelay: 2000
                  });
              })
              .catch(err => {
                  console.error("Session renewal failed", err);
                  this.sessionWarningModal = false;
                  this.sessionExpiredModal = true;
              });
      },
      logout() {
        this.$auth.logout();
      },
      toggleTheme() {
        this.darkMode = !this.darkMode;
        if (this.darkMode) {
            document.body.classList.add('dark-mode');
            localStorage.setItem('darkMode', 'true');
        } else {
            document.body.classList.remove('dark-mode');
            localStorage.setItem('darkMode', 'false');
        }
      }
  },
  computed: {
      isMobile() {
          return this.windowWidth < 991;
      },
      wrapperClasses() {
          if (this.isMobile) {
              return { 'nav-open': this.sidebarVisible };
          } else {
              return { 'sidebar-closed': !this.sidebarVisible };
          }
      }
  },
  watch: {
    isMobile(newVal) {
        // Reset sidebar state when switching modes
        if (newVal) {
            this.sidebarVisible = false; // Mobile: Default hidden
        } else {
            this.sidebarVisible = true; // Desktop: Default visible
        }
    }
  }
};
</script>

<style>/* Landing Page */
.landing-page {
  height: 100vh;
  width: 100%;
  background-color: #f7f7f8; 
  display: flex !important;
}

.landing-page .card {
  border: 1px solid rgba(0,0,0,.1);
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
/* 
 * Light Bootstrap Dashboard Styles Integration 
 * Simplified for this single-file integration
 */
 
body {
    color: #484848;
    background-color: #f7f7f8; /* Light gray background for main panel */
    font-size: 14px;
    font-family: "Helvetica Neue", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
}

.wrapper {
    position: relative;
    top: 0;
    height: 100vh;
}

/* Sidebar */
.sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 260px;
    display: block;
    z-index: 1000;
    color: #fff;
    font-weight: 200;
    background-size: cover;
    background-position: center center;
    background-color: #000;
    /* You can add a background image by setting data-image on the .sidebar div */
}

.sidebar .sidebar-wrapper {
    position: relative;
    max-height: none;
    min-height: 100%;
    overflow: auto;
    width: 260px;
    z-index: 4;
    padding-bottom: 30px;
}

.sidebar .logo {
    padding: 10px 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.sidebar .logo .simple-text {
    text-transform: uppercase;
    padding: 5px 0px;
    display: block;
    font-size: 18px;
    color: #FFFFFF;
    text-align: left;
    font-weight: 400;
    line-height: 30px;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.sidebar .nav {
    margin-top: 20px;
    float: none;
    display: block;
}

.sidebar .nav li .nav-link {
    color: #FFFFFF;
    margin: 5px 15px;
    opacity: .86;
    border-radius: 4px;
    text-transform: uppercase;
    font-size: 12px;
    padding: 10px 15px;
    display: flex; /* Flex to align icon and text */
    align-items: center;
    cursor: pointer;
    text-decoration: none;
}

.sidebar .nav li .nav-link:hover {
    background: rgba(255, 255, 255, 0.13);
    opacity: 1;
}

.sidebar .nav li.active > .nav-link {
    background-color: #1DC7EA; /* Light Bootstrap Dashboard Blue */
    color: #FFFFFF;
    opacity: 1;
    box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(29, 199, 234, 0.4);
}

.sidebar .nav p {
    margin: 0;
    line-height: normal;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.sidebar .nav .mini-text {
  width: 30px;
  text-align: center;
  margin-right: 5px;
  display: inline-block;
}

.sidebar .nav i {
    font-size: 24px;
    float: left;
    margin-right: 15px;
    line-height: 30px;
    width: 30px;
    text-align: center;
}

/* Submenus */
.sidebar .nav .nav {
  margin-top: 0;
  padding-left: 0;
}
.sidebar .nav .nav li .nav-link {
  margin: 5px 0; /* Tighter spacing for submenus */
  padding-left: 10px;
  text-transform: none; /* Submenus mixed case */
}


/* Main Panel */
.main-panel {
    background: rgba(203, 203, 210, 0.15); /* Light gray background */
    position: relative;
    float: right;
    width: calc(100% - 260px);
    min-height: 100%;
    transition: 0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1);
}

.main-panel > .content {
    padding: 30px 15px;
    min-height: calc(100vh - 123px);
}

.main-panel > .navbar {
    margin-bottom: 0;
}

/* Navbar */
.navbar {
    border: 0;
    border-radius: 0;
    font-size: 16px;
    background-color: #fff; /* White navbar */
    border-bottom: 1px solid rgba(0,0,0,.1);
    padding: 10px 15px;
}

.navbar .navbar-brand {
    font-weight: 400;
    margin: 5px 0px;
    font-size: 20px;
    color: #888;
}

.navbar .navbar-nav > li > a {
    color: #888;
    text-transform: uppercase;
    margin: 10px 15px;
}

/* Navbar Toggler */
.navbar-toggler {
    cursor: pointer; 
    padding: 0;
    width: 30px;
    height: 30px;
    outline: none !important;
}

.navbar-toggler .burger-lines {
    display: block;
    position: relative;
    background-color: #888; /* Dark gray color for visibility */
    width: 24px;
    height: 2px;
    border-radius: 1px;
    margin: 0 auto 5px;
    transition: all 0.2s ease;
}

/* Footer */
.footer {
     background-color: transparent;
    border-top: 1px solid #e7e7e7;
    padding: 15px 0;
}

.footer nav ul {
    margin-bottom: 0;
    float: left;
    list-style: none;
    padding: 0;
}

.footer nav ul li {
    display: inline-block;
}

.footer nav ul li a {
    color: #484848;
    padding: 10px 15px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 12px;
}

.footer .copyright {
    color: #888;
    padding: 10px 15px;
    font-size: 14px;
    margin: 0;
    text-align: right;
}

/* Card Styling mimicking Light Bootstrap */
.card {
    border-radius: 4px;
    background-color: #FFFFFF;
    margin-bottom: 30px;
    border: 1px solid rgba(0,0,0,.125);
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.card .card-header {
    background-color: transparent;
    border-bottom: 0;
    padding: 15px 15px 0;
}

.card .card-body {
    padding: 15px 15px 10px 15px;
}

/* Responsive adjustments */
@media (max-width: 991px) {
    .sidebar {
        /* display: none; */
        display: block;
        top: 0;
        bottom: 0;
        left: 0;
        right: auto;
        z-index: 1032;
        visibility: visible;
        overflow-y: visible;
        border-top: none;
        text-align: left;
        padding-right: 0;
        padding-left: 0;
        transform: translate3d(-260px, 0, 0);
        transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
        width: 260px;
        position: fixed;
    }
    
    .nav-open .main-panel {
        transform: translate3d(260px, 0, 0);
    }
    
    .nav-open .sidebar {
        transform: translate3d(0, 0, 0);
    }
    
    .navbar-toggler .burger-lines {
        transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
    }
    
    .nav-open .navbar-toggler .burger-lines:nth-child(1) {
        transform: rotate(45deg) translate(8px, 6px);
    }
    .nav-open .navbar-toggler .burger-lines:nth-child(2) {
        opacity: 0;
    }
    .nav-open .navbar-toggler .burger-lines:nth-child(3) {
        transform: rotate(-45deg) translate(8px, -6px);
    }

    .main-panel {
        width: 100%;
        float: none;
        transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
    }
}

/* Desktop Sidebar Toggle */
@media (min-width: 992px) {
    .sidebar {
        transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
    }
    .main-panel {
        transition: width 0.3s ease-in-out;
    }

    .sidebar-closed .sidebar {
        width: 0;
        overflow: hidden;
        transform: translateX(-260px);
    }
    
    .sidebar-closed .main-panel {
        width: 100%;
    }
}

/* Dark Mode Overrides */
body.dark-mode {
  color: #e0e0e0;
  background-color: #1e1e2f;
}

body.dark-mode .main-panel {
  background: #1e1e2f; 
}

body.dark-mode .navbar {
  background-color: #27293d;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

body.dark-mode .navbar .navbar-brand,
body.dark-mode .navbar .navbar-nav > li > a {
  color: #ffffff;
}

body.dark-mode .card {
  background-color: #27293d;
  color: #ffffff;
  box-shadow: 0 1px 15px 0 rgba(0, 0, 0, 0.2);
}

body.dark-mode .card .card-header,
body.dark-mode .card .card-footer {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.1);
}

body.dark-mode .card .card-title,
body.dark-mode .card h4,
body.dark-mode .card h5,
body.dark-mode .card h6 {
  color: #ffffff !important;
}

body.dark-mode .text-muted {
  color: #9a9a9a !important;
}

body.dark-mode .text-dark {
  color: #ffffff !important; 
}

body.dark-mode .bg-light {
    background-color: #1e1e2f !important;
}

body.dark-mode .bg-white {
    background-color: #27293d !important;
}

body.dark-mode .border, 
body.dark-mode .border-top, 
body.dark-mode .border-bottom,
body.dark-mode .border-left,
body.dark-mode .border-right {
    border-color: rgba(255, 255, 255, 0.1) !important;
}

/* Buttons in dark mode */
body.dark-mode .btn-simple {
    color: #ffffff;
}

body.dark-mode .form-control {
    background-color: #1b1b26;
    border-color: #2b3553;
    color: #ffffff;
}

body.dark-mode .form-control:focus {
    background-color: #1b1b26;
    color: #ffffff;
}

/* Modals */
body.dark-mode .modal-content {
    background-color: #27293d;
    color: #ffffff;
}
body.dark-mode .close {
    color: white;
    text-shadow: none;
}

/* Mobile Overlay */
.mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.5);
    z-index: 1031; /* Below sidebar (1032) but above content */
    cursor: pointer;
}
</style>
